<template>
  <div class="car-approval-record page-padding">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.car-approval-record {
    width: 100%;
    height: 100%;
}
</style>